import { ApiProductType } from '~/core/enums/api-product-type.enum';
import { StoreModel } from '~/core/models';

interface buildProductsUrlParams {
  zipcode: string;
  qteGrpID?: number | null;
  selectedStore: StoreModel;
}

export const buildProductsUrl =
  (productType: ApiProductType) =>
  ({ zipcode, qteGrpID, selectedStore }: buildProductsUrlParams): string => {
    const params = [
      `zipCode=${zipcode}`,
      `storeId=${selectedStore.companyId}`,
      ...(qteGrpID ? [`prodQteGrpID=${qteGrpID}`] : []),
    ];

    return `/products/${productType}?${params.join('&')}`;
  };
//TODO: replace with RTK-Query logic
export const buildCutoutLaborProductsUrl = buildProductsUrl(
  ApiProductType.CUTOUT_LABOR
);
//TODO: replace with RTK-Query logic
export const buildOptionalItemsProductsUrl = buildProductsUrl(
  ApiProductType.OPTIONAL_ITEMS
);
//TODO: replace with RTK-Query logic
export const buildWaterfallLaborProductsUrl = buildProductsUrl(
  ApiProductType.WATERFALL_LABOR
);
